import { PromotionRewardType } from '@repo/api/web/models'

export function isCashbackRewardType(
  rewardType?: PromotionRewardType | null,
): boolean {
  return rewardType === PromotionRewardType.PERCENTCASHBACK
    || rewardType === PromotionRewardType.FIXEDAMOUNTCASHBACK
}
